<span id="timer">{{ displayTime }}</span> 